module.exports = __webpack_public_path__ + "static/media/avial.4226fb8c.webp";